import { Flex, FlexProps } from "@chakra-ui/react"
import React, { FC } from "react"

export const VFlex: FC<FlexProps> = (props) => <Flex direction="column" {...props} />
